import { render } from "./ProductSelector.vue?vue&type=template&id=18c49f20&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=js"
export * from "./ProductSelector.vue?vue&type=script&lang=js"

import "./ProductSelector.vue?vue&type=style&index=0&id=18c49f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c49f20"]])

export default __exports__